import { render, staticRenderFns } from "./gl-footer-menu.vue?vue&type=template&id=6cd91b12"
import script from "./gl-footer-menu.vue?vue&type=script&lang=js"
export * from "./gl-footer-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports